import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import {
  NUMBER_OF_ALLOWED_CONDITIONGROUPS,
  WorkFlowMatchOptions,
} from 'routes/screens/wflow/constants';
import { WorkflowCard } from 'routes/screens/wflow/styles';
import { WorkFlowMatchOptionType } from 'routes/screens/wflow/types';
import { ActionButton } from 'routes/styles';
import Icon from 'shared/components/Icon';
import SwitchButton from 'shared/components/SwitchButton';
import {
  SurveyType,
  WorkflowConditionOptions,
  WorkflowType,
} from 'shared/types';
import ConditionGroup from './condition-group';

type WorkflowConditionProps = {
  id?: string;
  disabled: boolean;
  surveyData?: SurveyType;
  isFetchingSurvey?: boolean;
};

const WorkflowCondition = (props: WorkflowConditionProps) => {
  const { disabled, surveyData, isFetchingSurvey } = props;
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<WorkflowType>();

  const condition_groups = watch('condition_groups');

  const onAddConditionGroup = () => {
    const newConditionGroups = [...(condition_groups || [])];
    newConditionGroups.push({
      conditions_operator: 'OR',
      conditions: [{}],
    });
    setValue('condition_groups', newConditionGroups);
  };

  const workFlowMatchOptions = React.useMemo(() => {
    return Object.keys(WorkFlowMatchOptions).map((key) => ({
      id: key as WorkflowConditionOptions,
      label: t(WorkFlowMatchOptions[key]),
    }));
  }, []);

  return (
    <WorkflowCard>
      <div className="wf-title">{`2. ${
        t('workflow.condition.title') || ''
      }`}</div>
      <div className="wf-description">{t('workflow.condition.desc') || ''}</div>
      <div className="wf-row-condition">
        <Trans
          i18nKey="workflow.condition.condition_groups"
          components={{
            switchButton: (
              <SwitchButton
                value={watch('condition_groups_operator') || ''}
                disabled={disabled}
                onChange={(item: WorkFlowMatchOptionType) =>
                  setValue('condition_groups_operator', item.id)
                }
                items={workFlowMatchOptions}
                itemLabelIdentifier="label"
                itemValueIdentifier="id"
              />
            ),
          }}
        />
      </div>
      {condition_groups?.map((cg, idx) => (
        <ConditionGroup
          key={cg.id}
          disabled={disabled}
          conditionGroupIndex={idx}
          conditionGroup={cg}
          conditionGroupLength={condition_groups.length}
          surveyData={surveyData}
          isFetchingSurvey={isFetchingSurvey}
        />
      ))}
      <ActionButton
        onClick={onAddConditionGroup}
        className={
          disabled ||
          (condition_groups &&
            condition_groups?.length >= NUMBER_OF_ALLOWED_CONDITIONGROUPS)
            ? 'disabled'
            : ''
        }
      >
        <div>
          <Icon width="12" height="12" glyph="plus" />
        </div>
        <div>{t('workflow.condition.group')}</div>
      </ActionButton>
    </WorkflowCard>
  );
};

export default WorkflowCondition;
